import React from "react";
import "./loader.css";
import { Text } from "../common";

export default function Loader({ height }) {
  return (
    <div
      style={{
        height: height || "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div className="loader" />
      <Text text={"LOADING"} style={{ fontWeight: "bold", paddingTop: 20 }} />
    </div>
  );
}
